// Manual Audit Logs Module labels (API path → display name). Add new APIs here.
export const AUDIT_LOG_MODULE_LABELS = {
  // Dashboard & common
  dashboard_metrics: "Dashboard Metrics",
  auditLogs: "Audit Logs",
  notifications: "Notifications",

  // Workflow create / library
  get_workflows: "Workflow List",
  wf_name_check: "Workflow Name Check",
  submitTask: "Submit Forecast Task",
  getDateRange: "Date Range",
  getDataAvailability: "Data Availability",
  getSalesDataInfo: "Sales Data Info",
  masterdata: "Master Data",
  getproducthierarchy: "Product Hierarchy",
  getgeohierarchy: "Geography Hierarchy",
  upload_exog_files: "Upload External Files",
  exog_event_list: "External Event List",
  exog_event_addition: "Add External Event",
  "api/events/bulk-upload": "Bulk Upload Events",

  // Forecast results
  getActPredFcastResults: "Actual vs Predicted Results",
  getForecastResults: "Forecast Results",
  getTopOneModelResults: "Top Model Results",
  getTopThreeModelResults: "Top 3 Model Results",
  getmultipleModelResults: "Multiple Model Results",
  getmultipleActPredFcastResults: "Multiple Actual vs Predicted",
  getmultipleForecastResults: "Multiple Forecast Results",

  // Feature-based forecasting
  "feature-based/getProductTypes": "Feature Product Types",
  "feature-based/getFeatureFilters": "Feature Filters",
  "feature-based/getFeatureMatchingSkus": "Feature Matching SKUs",
  "feature-based/getFeatureCombinations": "Feature Combinations",
  "feature-based/getAggregatedActualPredictedResults": "Feature Forecast Results",
  "feature-based/getContributionBreakdown": "Feature Contribution Breakdown",
  "feature-based/getWorkflowFeatureGroups": "Workflow Feature Groups",

  // Indentation / inventory
  getCombinedSKUs: "Combined SKUs",
  getIndentationforecast: "Indentation Forecast",
  getIndentationforecastEOQ: "Indentation Forecast (EOQ)",

  // Sales person
  get_sp: "Sales Persons",
  get_all_sp: "All Sales Persons",
  add_sp: "Add Sales Person",
  get_sp_sku_mapping: "Sales Person–SKU Mapping",
  assign_skus: "Assign SKUs",
  send_email_f_skus: "Email SKU Assignments",
  get_wf_for_sp: "Workflows for Sales Person",

  // Collaboration / planned forecast
  get_fp: "Planned Forecast Data",
  upload_forecast: "Upload Planned Forecast",
  update_fcast_values: "Update Forecast Values",

  // Quality check
  "qc/upload": "QC Upload",
  "qc/fix": "QC Fix Data",
  "qc/commit": "QC Commit",
  "qc/delete": "QC Delete Upload",

  // Supply chain
  "scm/management": "Supply Chain Management",
  "scm/vendors": "Vendor Configuration",

  // Conjoint & trend
  "conjoint/filters": "Conjoint Filters",
  "conjoint/dashboard-data": "Conjoint Dashboard",
  "trend/data": "Trend Data",
  "trend/conjoint-importance": "Trend Conjoint Importance",
  "trend/conjoint-part-worth": "Trend Conjoint Part Worth",
};

// Lowercase key map for fast case-insensitive lookup
const LABEL_LOOKUP = Object.fromEntries(
  Object.entries(AUDIT_LOG_MODULE_LABELS).map(([k, v]) => [k.toLowerCase(), v])
);

// Manual map only; unmapped paths return the raw path
export function getAuditLogModuleLabel(path) {
  if (!path || path === "-") return "-";
  const key = String(path).split("?")[0].trim().replace(/^\/+|\/+$/g, "");
  if (!key) return "-";
  const lower = key.toLowerCase();
  const match = Object.keys(LABEL_LOOKUP).find((k) => lower === k || lower.startsWith(`${k}/`));
  return match ? LABEL_LOOKUP[match] : key;
}
